// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2XjIn","select":"Header_select__3ud-B","clinic":"Header_clinic__sWw6A"};